function checkTotalPrice() {
  var url = "/cart.json";
  var request = new XMLHttpRequest();
  var result = "";
  request.open("GET", url, false);
  request.onreadystatechange = function () {
      if (request.readyState != 4) {
          // リクエスト中
      } else if (request.status != 200) {
          // 失敗
      } else {
          // 取得成功
          result = request.responseText;
      }
  }
  request.send(null);
  let resultData = JSON.parse(result);
  var element = document.getElementById("cart-privileges");

  
  if(resultData.original_total_price > 600000){
    return true;
  } else {
    return false;
  }
  
}

var privilege_counter = 0;

function setPrivilege(){

  if(privilege_counter == 0){
    // 「gift-target」タグの付いた商品を1点以上で合計¥3,000以上の時にギフト商品追加
    //if (document.getElementById("giftCheck") != null) { selectPrivilegeProductGift('43882883940605'); }
    // 「gift-target2」のタグがついた商品を￥2,000以上の時にギフト商品追加
    //if (document.getElementById("giftCheck01") != null) { selectPrivilegeProductGift01('43882884202749'); }
    // 「gift-target」のタグが付けられた商品を1点以上の時にギフト商品追加
    //if (document.getElementById("giftCheck02") != null) { selectPrivilegeProductGift02('43885399343357'); }
  
    // 「gift-clever2023」のタグが付けられた商品を1点以上の時にギフト商品追加
    //if (document.getElementById("giftCheckClever") != null) { selectPrivilegeProductClever2023('44107103961341'); }
  
    // 5000円以上購入時にギフト商品追加
    //if (document.getElementById("giftCheckOmake010") != null) { selectPrivilegeProductOmake010('44258149630205'); }
  
    // 「gift-lavons2024」のタグが付けられた商品を1点以上の時にギフト商品追加
    //if (document.getElementById("giftCheckLavons") != null) { selectPrivilegeProductLavons2024('45839098249469'); }

    // 「gift-KGMARO」のタグが付けられた商品を1点以上の時にギフト商品追加
    // if (document.getElementById("giftCheckKGMARO") != null) { selectPrivilegeProductKGMARO('46062294139133'); }

    // 「gift-lavons202503」のタグが付けられた商品を1点以上の時にギフト商品追加
    //if (document.getElementById("giftCheckLAVONS202503") != null) { selectPrivilegeProductLAVONS202503('46145122566397'); }

    // 「gift_lavons202504」のタグが付けられた商品を1点以上の時にギフト商品追加
    if (document.getElementById("giftCheckLAVONS202504") != null) { selectPrivilegeProductLAVONS202504('46214134366461'); }
    
    privilege_counter++;
  }
  
}


// 「girt-clever2023」のタグが付いた商品を1個以上購入するとギフト商品追加される機能
/*function selectPrivilegeProductClever2023(id){
  //alert(id);
  clearPrivilegeProduct(id);
  const giftCheckClever = document.getElementById("giftCheckClever").value;
  if(giftCheckClever == "true") {
    var data =  {
      items: [
        {
          "id": parseInt(id),
          "quantity": 1,
        },
      ],
    }

    var url = "/cart/add.js";
    var request = new XMLHttpRequest();
    var result = "";
    request.onreadystatechange = function() {
      if (request.readyState != 4) {
        // リクエスト中
      } else if (request.status != 200) {
        // 失敗
      } else {
        // 取得成功
        result = request.responseText;
      }
    }

    request.open('POST', url, false);
    request.setRequestHeader('Content-Type', 'application/json');
    request.send(JSON.stringify(data));
  }

  return true;
}*/

//  5000円以上購入するとギフト商品追加される機能
function selectPrivilegeProductOmake010(id){
  //alert(id);
  clearPrivilegeProduct(id);
  const giftCheckOmake010 = document.getElementById("giftCheckOmake010").value;
  if(giftCheckOmake010 == "true") {
    var data =  {
      items: [
        {
          "id": parseInt(id),
          "quantity": 1,
        },
      ],
    }

    var url = "/cart/add.js";
    var request = new XMLHttpRequest();
    var result = "";
    request.onreadystatechange = function() {
      if (request.readyState != 4) {
        // リクエスト中
      } else if (request.status != 200) {
        // 失敗
      } else {
        // 取得成功
        result = request.responseText;
      }
    }

    request.open('POST', url, false);
    request.setRequestHeader('Content-Type', 'application/json');
    request.send(JSON.stringify(data));
  }

  return true;
}

// 「girt-target」のタグが付いた商品を1個以上購入するとギフト商品追加される機能
function selectPrivilegeProductGift02(id){
  clearPrivilegeProduct(id);
  const giftCheck02 = document.getElementById("giftCheck02").value;
  if(giftCheck02 == "true") {
    var data =  {
      items: [
        {
          "id": parseInt(id),
          "quantity": 1,
        },
      ],
    }

    var url = "/cart/add.js";
    var request = new XMLHttpRequest();
    var result = "";
    request.onreadystatechange = function() {
      if (request.readyState != 4) {
        // リクエスト中
      } else if (request.status != 200) {
        // 失敗
      } else {
        // 取得成功
        result = request.responseText;
      }
    }

    request.open('POST', url, false);
    request.setRequestHeader('Content-Type', 'application/json');
    request.send(JSON.stringify(data));
  }

  return true;
}
// 「gift-target2」のタグがついた商品を¥2,000以上購入するとギフト商品追加される機能
/*function selectPrivilegeProductGift01(id){
  clearPrivilegeProduct(id);
  const giftCheck01 = document.getElementById("giftCheck01").value;
  if(giftCheck01 == "true") {
    var data =  {
      items: [
        {
          "id": parseInt(id),
          "quantity": 1,
        },
      ],
    }

    var url = "/cart/add.js";
    var request = new XMLHttpRequest();
    var result = "";
    request.onreadystatechange = function() {
      if (request.readyState != 4) {
        // リクエスト中
      } else if (request.status != 200) {
        // 失敗
      } else {
        // 取得成功
        result = request.responseText;
      }
    }

    request.open('POST', url, false);
    request.setRequestHeader('Content-Type', 'application/json');
    request.send(JSON.stringify(data));
  }

  return true;
}*/

// 「gift-target」タグの付いた商品を1点以上で合計¥3,000以上の時にギフト商品追加される機能
function selectPrivilegeProductGift(id){
  clearPrivilegeProduct(id);
  const giftCheck = document.getElementById("giftCheck").value;
  if(giftCheck == "true") {
    var data =  {
      items: [
        {
          "id": parseInt(id),
          "quantity": 1,
        },
      ],
    }

    var url = "/cart/add.js";
    var request = new XMLHttpRequest();
    var result = "";
    request.onreadystatechange = function() {
      if (request.readyState != 4) {
        // リクエスト中
      } else if (request.status != 200) {
        // 失敗
      } else {
        // 取得成功
        result = request.responseText;
      }
    }

    request.open('POST', url, false);
    request.setRequestHeader('Content-Type', 'application/json');
    request.send(JSON.stringify(data));
  }

  return true;
}

// 「girt-lavons2024」のタグが付いた商品を1個以上購入するとギフト商品追加される機能
function selectPrivilegeProductLavons2024(id){
  //alert(id);
  clearPrivilegeProduct(id);
  const giftCheckLavons = document.getElementById("giftCheckLavons").value;
  if(giftCheckLavons == "true") {
    var data =  {
      items: [
        {
          "id": parseInt(id),
          "quantity": 1,
        },
      ],
    }

    var url = "/cart/add.js";
    var request = new XMLHttpRequest();
    var result = "";
    request.onreadystatechange = function() {
      if (request.readyState != 4) {
        // リクエスト中
      } else if (request.status != 200) {
        // 失敗
      } else {
        // 取得成功
        result = request.responseText;
      }
    }

    request.open('POST', url, false);
    request.setRequestHeader('Content-Type', 'application/json');
    request.send(JSON.stringify(data));
    //alert(result);
  }
  //alert(giftCheckLavons);

  return true;
}

// 「gift-KGMARO」のタグが付いた商品を1個以上購入するとギフト商品追加される機能
function selectPrivilegeProductKGMARO(id){
  //alert(id);
  clearPrivilegeProduct(id);
  const giftCheckKGMARO = document.getElementById("giftCheckKGMARO").value;
  if(giftCheckKGMARO == "true") {
    var data =  {
      items: [
        {
          "id": parseInt(id),
          "quantity": 1,
        },
      ],
    }

    var url = "/cart/add.js";
    var request = new XMLHttpRequest();
    var result = "";
    request.onreadystatechange = function() {
      if (request.readyState != 4) {
        // リクエスト中
      } else if (request.status != 200) {
        // 失敗
      } else {
        // 取得成功
        result = request.responseText;
      }
    }

    request.open('POST', url, false);
    request.setRequestHeader('Content-Type', 'application/json');
    request.send(JSON.stringify(data));
    //alert(result);
  }
  //alert(giftCheckMaroKG);

  return true;
}

// 「gift_lavons202504」のタグが付いた商品を1個以上購入するとギフト商品追加される機能
function selectPrivilegeProductLAVONS202504(id){
  //alert(id);
  clearPrivilegeProduct(id);
  const giftCheckLAVONS202504 = document.getElementById("giftCheckLAVONS202504").value;
  var cartTotalPrice = parseInt(document.getElementById("cartTotalPrice").value);
  var omakeNum = 0
  //console.log(cartTotalPrice);

  // 購入金額によっておまけの個数を変更する
  if(cartTotalPrice > 0){
    omakeNum = Math.floor(cartTotalPrice / 300000);
  } else {
    omakeNum = 0;
  }
  //alert(omakeNum);
  
  if(giftCheckLAVONS202504 == "true") {
    var data =  {
      items: [
        {
          "id": parseInt(id),
          "quantity": omakeNum,
        },
      ],
    }

    var url = "/cart/add.js";
    var request = new XMLHttpRequest();
    var result = "";
    request.onreadystatechange = function() {
      if (request.readyState != 4) {
        // リクエスト中
      } else if (request.status != 200) {
        // 失敗
      } else {
        // 取得成功
        result = request.responseText;
      }
    }

    request.open('POST', url, false);
    request.setRequestHeader('Content-Type', 'application/json');
    request.send(JSON.stringify(data));
    //alert(result);
  }
  //alert(giftCheckMaroKG);

  return true;
}

function selectPrivilegeProductLAVONS202503(id){
  //alert(id);
  clearPrivilegeProduct(id);
  const giftCheckLAVONS202503 = document.getElementById("giftCheckLAVONS202503").value;
  if(giftCheckLAVONS202503 == "true") {
    var data =  {
      items: [
        {
          "id": parseInt(id),
          "quantity": 1,
        },
      ],
    }

    var url = "/cart/add.js";
    var request = new XMLHttpRequest();
    var result = "";
    request.onreadystatechange = function() {
      if (request.readyState != 4) {
        // リクエスト中
      } else if (request.status != 200) {
        // 失敗
      } else {
        // 取得成功
        result = request.responseText;
      }
    }

    request.open('POST', url, false);
    request.setRequestHeader('Content-Type', 'application/json');
    request.send(JSON.stringify(data));
    //alert(result);
  }
  //alert(giftCheckMaroKG);

  return true;
}

function selectPrivilegeProduct(id){
  clearPrivilegeProduct(id);
  var checkPriceFlg = checkTotalPrice();

  if(checkPriceFlg){
    var data =  {
      items: [
        {
          "id": id,
          "quantity": 1,
        },
      ],
    }
    //console.log(data);

    var url = "/cart/add.js";
    var request = new XMLHttpRequest();
    var result = "";
    request.onreadystatechange = function() {
      if (request.readyState != 4) {
        // リクエスト中
      } else if (request.status != 200) {
        // 失敗
      } else {
        // 取得成功
        result = request.responseText;
      }
    }

    request.open('POST', url, false);
    request.setRequestHeader('Content-Type', 'application/json');
    request.send(JSON.stringify(data));
  
  }
  
  return true;
  
}

function clearPrivilegeProduct(id){
  var data =  {
    'id': id,
    'quantity': 0,
  };
  
  var url = "/cart/change.js";
  var request = new XMLHttpRequest();
  var result = "";
  request.onreadystatechange = function() {
    if (request.readyState != 4) {
      // リクエスト中
    } else if (request.status != 200) {
      // 失敗
    } else {
      // 取得成功
      result = request.responseText;
    }
  }
  request.open('POST', url, false);
  request.setRequestHeader('Content-Type', 'application/json');
  request.send(JSON.stringify(data));
  
}
